import { render, staticRenderFns } from "./TravelInsurance.vue?vue&type=template&id=3e1bfe68&scoped=true"
import script from "./TravelInsurance.vue?vue&type=script&lang=js"
export * from "./TravelInsurance.vue?vue&type=script&lang=js"
import style0 from "./TravelInsurance.vue?vue&type=style&index=0&id=3e1bfe68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1bfe68",
  null
  
)

export default component.exports